import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';
import notify, { MESSAGES } from '../../utils/notify';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import '../TenderOpening/components/TenderOpening.css';
import RequestHpsTable from './component/RequestHpsTable';

const ProcurementList = () => {
  const token = getAuthToken();
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Authentication validation
  useEffect(() => {
    if (!token) {
      notify.error(MESSAGES.authRequired);
      return;
    }
    if (!isAuthenticated()) {
      notify.error(MESSAGES.authRequired);
      return;
    }
  }, [token]);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  document.title = 'List Request HPS ';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
            <div className='email-content minimal-border'>
              <div className='p-4'>
                <div className='to-hero mb-4'>
                  <PageBreadcrumb
                    fallback={{
                      label: 'Request HPS',
                      to: '/apps-requesthps/view',
                    }}
                  />

                  <div className='d-flex align-items-center gap-3 flex-wrap'>
                    <span className='to-hero-icon'>
                      <i className='ri-price-tag-3-line' aria-hidden='true' />
                    </span>
                    <div className='flex-grow-1'>
                      <h4 className='to-hero-title'>Request HPS</h4>
                      <p className='to-hero-subtitle'>
                        Fill in the HPS for submitted procurements and follow
                        each request until it is submitted.
                      </p>
                    </div>
                    <button
                      type='button'
                      className='to-hero-btn'
                      onClick={handleRefresh}
                    >
                      <i className='ri-refresh-line' aria-hidden='true' />
                      Refresh
                    </button>
                  </div>
                </div>

                <RequestHpsTable
                  refreshTrigger={refreshTrigger}
                  exportName='Request HPS'
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProcurementList;
